export const Roles = {
    admin: "admin",
    web_admin: "web_admin",
    customer: "customer"
}
